export default (state, action) => {
  switch (action.type) {
    case 'GET_CLOUD':
    case 'PATCH_CLOUD':
      return {
        ...state,
        cloud: action.payload,
      };

    case 'SET_LOADING': {
      return {
        ...state,
        updateLoading: action.payload,
      };
    }

    case 'SET_ERRORS': {
      return {
        ...state,
        errors: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
